import styled from 'styled-components';

export const SkolonMenuButtonContainer = styled.div`
  display: flex;
  margin-right: 15px;
`;
